import type { BackendConfig } from '../env'
import { createLocalBackend } from './localBackend'
import { createSupabaseBackend } from './supabaseBackend'
import type { WritingsBackend } from './types'

export type { WritingsBackend } from './types'

export function createBackend(config: BackendConfig): WritingsBackend {
  return config.mode === 'supabase' ? createSupabaseBackend(config.url, config.anonKey) : createLocalBackend()
}
